import { render, staticRenderFns } from "./DashboardMemosRail.vue?vue&type=template&id=65faf9b9&scoped=true&"
import script from "./DashboardMemosRail.vue?vue&type=script&lang=js&"
export * from "./DashboardMemosRail.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMemosRail.vue?vue&type=style&index=0&id=65faf9b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65faf9b9",
  null
  
)

export default component.exports
import {QIcon,QSpinnerTail,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QSpinnerTail,QBtn})
